export default __webpack_public_path__ + "static/media/dropFile.86dbf99a.svg";